"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SENSOR_IDS = void 0;
__exportStar(require("./SensorSort"), exports);
__exportStar(require("./SensorPublished"), exports);
__exportStar(require("./SensorCollection"), exports);
__exportStar(require("./SensorSearchTerm"), exports);
__exportStar(require("./SensorInventoryAvailable"), exports);
__exportStar(require("./Sensors"), exports);
// this is consumed by the react prop in various components
const SENSOR_IDS = (mode, config) => {
    const sensorIds = [
        "SensorSort",
        "SensorPublished",
        "SensorCollection",
        "SensorSearchTerm",
        "SensorInventoryAvailable",
    ];
    const customSensors = mode === "collection" ? config.sensors.collection : config.sensors.search;
    if (customSensors.length > 0) {
        sensorIds.push(...customSensors.map((item, index) => `SensorCustom_${index}`));
    }
    return sensorIds;
};
exports.SENSOR_IDS = SENSOR_IDS;
//# sourceMappingURL=index.js.map